import { _post } from "../../Api";
import articlesStore from "./ArticlesStore";
import { CreateModifiergroup } from "./models/Modifiergroup";
import { setArticles, setModifierarticles, setModifiergroups, setTranslations } from "./ArticlesActions";
import { toast } from "react-toastify";
import convertToJson from "../../helper/convertToJson";
import { Article } from "./models/Article";
import { Modifierarticle } from "./models/Modifierarticle";

export function createModifiergroups(merchantId, modifiergroups) {
  const modifiergroupsJSON = modifiergroups.map((modifiergroup) => convertToJson(modifiergroup));
  return _post("/nova/v2/merchant/" + merchantId + "/modifiergroups", modifiergroupsJSON)
    .catch(() => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    })
    .then((res) => {
      const newModifiergroups = { ...articlesStore.modifiergroups };
      const newArticles = { ...articlesStore.articles };
      const newModifierarticles = { ...articlesStore.modifierarticles };

      res.data.forEach((modifiergroup) => {
        let newModifiergroup = CreateModifiergroup(
          modifiergroup,
          modifiergroup.m_modifierarticles.map((m) => m.id),
          modifiergroup.m_articles.map((m) => m.id)
        );
        newModifiergroups[newModifiergroup.id] = newModifiergroup;
        modifiergroup.m_articles.forEach((m_article) => {
          const newArticle = Object.assign(new Article(), newArticles[m_article.id]);
          if (!newArticle.modifiergroupIds.includes(newModifiergroup.id)) {
            newArticle.modifiergroupIds.push(newModifiergroup.id);
            newArticles[newArticle.id] = newArticle;
          }
        });

        modifiergroup.m_modifierarticles.forEach((m_modifierarticle) => {
          const newModifierarticle = Object.assign(new Modifierarticle(), newModifierarticles[m_modifierarticle.id]);
          if (!newModifierarticle.modifiergroupIds.includes(newModifiergroup.id)) {
            newModifierarticle.modifiergroupIds.push(newModifiergroup.id);
            newModifierarticles[newModifierarticle.id] = newModifierarticle;
          }
        });
      });
      setModifiergroups(newModifiergroups);
      setArticles(newArticles);
      setModifierarticles(newModifierarticles);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateModifiergroups(merchantId, modifiergroups, newData, oldValues) {
  let data = [];
  for (let i in modifiergroups) {
    data.push({
      modifiergroupId: modifiergroups[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/modifiergroups", data)
    .catch((e) => {
      let newModifiergroups = { ...articlesStore.modifiergroups };
      modifiergroups.forEach((modifiergroup) => {
        newModifiergroups[modifiergroup.id].updated_at = new Date().toLocaleString();
      });
      setModifiergroups(newModifiergroups);
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      const newModifiergroups = { ...articlesStore.modifiergroups };
      const newArticles = { ...articlesStore.articles };
      const newModifierarticles = { ...articlesStore.modifierarticles };

      res.data.forEach((modifiergroup) => {
        let newModifiergroup = CreateModifiergroup(
          modifiergroup,
          modifiergroup.m_modifierarticles.map((m) => m.id),
          modifiergroup.m_articles.map((m) => m.id)
        );
        newModifiergroups[newModifiergroup.id] = newModifiergroup;
        modifiergroup.m_articles.forEach((m_article) => {
          const newArticle = Object.assign(new Article(), newArticles[m_article.id]);
          if (!newArticle.modifiergroupIds.includes(newModifiergroup.id)) {
            newArticle.modifiergroupIds.push(newModifiergroup.id);
            newArticles[newArticle.id] = newArticle;
          }
        });

        modifiergroup.m_modifierarticles.forEach((m_modifierarticle) => {
          const newModifierarticle = Object.assign(new Modifierarticle(), newModifierarticles[m_modifierarticle.id]);
          if (!newModifierarticle.modifiergroupIds.includes(newModifiergroup.id)) {
            newModifierarticle.modifiergroupIds.push(newModifiergroup.id);
            newModifierarticles[newModifierarticle.id] = newModifierarticle;
          }
        });
      });
      setModifiergroups(newModifiergroups);
      setArticles(newArticles);
      setModifierarticles(newModifierarticles);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateModifiergroupsTranslations(merchantId, modifiergroups, newData, oldValues) {
  let data = [];
  for (let i in modifiergroups) {
    data.push({
      modifiergroupId: modifiergroups[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/modifiergroups", data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let newTranslations = { ...articlesStore.translations };
      let newModifiergroups = { ...articlesStore.modifiergroups };

      res.data.forEach((modifiergroup) => {
        const newTranslation = modifiergroup.translation;
        newTranslations[newTranslation.id] = newTranslation;

        if (newModifiergroups[modifiergroup.id].translation_id !== newTranslation.id) {
          let newModifiergroup = CreateModifiergroup(
            modifiergroup,
            modifiergroup.m_modifierarticles.map((modifierarticle) => modifierarticle.id),
            modifiergroup.m_articles.map((marticle) => marticle.id)
          );
          newModifiergroups[newModifiergroup.id] = newModifiergroup;
        }
      });

      setModifiergroups(newModifiergroups);
      setTranslations(newTranslations);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}
